import {Injectable} from '@angular/core';
import {AppAnalyticsConstants} from '../../enums/app-analytics-constants';

declare var gtag: any; // Declare gtag as a global variable

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  constructor() {
  }


  /**
   * This is a generic method for tracking events in the application.
   * @param eventParameter this parameter represented name of the action name in Google Analytics
   * @param eventName this parameter represented name of the definition name in Google Analytics
   * @param screenName this parameter represented screen name of which user triggered event
   */
  trackEvents(eventParameter: string, eventName: string, screenName: string) {
    gtag('event', eventName, {
      [screenName]: eventParameter,
      event_label: eventParameter,
    });
  }

  /**
   * This method is used to track events related to actions performed on table headers.
   * @param moduleName this parameter represented name of the module
   * @param actionName this parameter represented name of action which user triggered
   */
  trackTableHeaderActions(moduleName: string, actionName: string) {
    this.trackEvents(actionName, moduleName, AppAnalyticsConstants.TABLE_HEADER_ACTIONS);
  }

  /**
   * This method is used to track events related to actions performed on table headers.
   * @param moduleName this parameter represented name of the module
   * @param actionName this parameter represented name of action which user triggered
   */
  trackNestedTableEvent(actionName: string, moduleName: string) {
    this.trackEvents(actionName, moduleName, AppAnalyticsConstants.TABLE_ACTIONS);
  }

  /**
   * This method is used to track events related to actions performed on table headers.
   * @param moduleName this parameter represented name of the module
   * @param actionName this parameter represented name of action which user triggered
   */
  trackCreateScreensEvents(actionName , moduleName) {
    this.trackEvents(actionName , moduleName , AppAnalyticsConstants.CREATE_SCREEN);
  }

  /**
   * This method is used to track events related to actions performed on table headers.
   * @param moduleName this parameter represented name of the module
   * @param actionName this parameter represented name of action which user triggered
   */
  trackScreensNavigationEvents(actionName , moduleName) {
    this.trackEvents(actionName , moduleName , AppAnalyticsConstants.SCREEN_NAVIGATION);
  }

  /**
   * This method is used to track events related to actions performed on table headers.
   * @param actionName this parameter represented name of action which user triggered
   */
  trackBillApproveScreensEvents(actionName) {
    this.trackEvents(actionName , AppAnalyticsConstants.MODULE_NAME_BILL , AppAnalyticsConstants.BILL_APPROVE_SCREEN);
  }

  /**
   * This method is used to track events related to actions performed on table headers.
   * @param actionName this parameter represented name of action which user triggered
   */
  trackPaymentApproveScreensEvents(actionName) {
    this.trackEvents(actionName , AppAnalyticsConstants.MODULE_NAME_PAYMENT , AppAnalyticsConstants.PAYMENT_APPROVE_SCREEN);
  }

  /**
   * This method is used to track events related to actions performed on table headers.
   * @param actionName this parameter represented name of action which user triggered
   */
  trackPayScreensEvents(actionName) {
    this.trackEvents(actionName , AppAnalyticsConstants.MODULE_NAME_PAYMENT , AppAnalyticsConstants.PAY_SCREEN);
  }

  /**
   * This method is used to track events related to actions performed on table headers.
   * @param actionName this parameter represented name of action which user triggered
   */
  trackProcessBillScreensEvents(actionName) {
    this.trackEvents(actionName , AppAnalyticsConstants.MODULE_NAME_BILL , AppAnalyticsConstants.PROCESS_BILL_SCREEN);
  }

  /**
   * This method is used to track events related to actions performed on table headers.
   * @param moduleName this parameter represented name of the module
   * @param actionName this parameter represented name of action which user triggered
   */
  trackUploadScreensEvents(actionName , moduleName) {
    this.trackEvents(actionName , moduleName , AppAnalyticsConstants.UPLOAD_SCREEN);
  }

}

